// @flow @jsx h

import { h } from 'preact'
import { StemningIcon } from '../StemningIcon/StemningIcon'

import styles from './Branding.css'
import { bem } from '../../helpers/bem'
import { themeToClassName } from '../../helpers/themeToClassName'

export const Branding = (props: any, context: { theme: string }) => {
  return (
    <div className={bem(styles.branding, themeToClassName(context.theme))} aria-hidden>
      <StemningIcon />
      <span>Avstemning</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/Branding/Branding.js